import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

const _state = {

}

const _getters = {
  canUseWheelToScrollThroughSlideList: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-wheel-to-scroll-through-slide-list')
  },
}

const mutations = {

}

const actions = {
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
